<div class="settings-container">
  <form [formGroup]="basicSettingsForm" class="form basic-settings" *ngIf="!subsidiariesLoading">
    <div class="standard-input" *ngIf="allSubsidiaries.length > 1">
      <label for="subsidary">
        {{ "Catalogs.new_catalog.settings.subsidary" | translate }}
      </label>
      <mat-select #subsidarySelect name="subsidiary" formControlName="subsidiary_id" [disabled]="defaultCatalogData?.status === 'Approved' || allSubsidiaries.length === 1">
        <mat-select-trigger>
          <span class="tag">{{ selectedSubsidiary?.name || 'Select a subsidary' | translate }}</span>
        </mat-select-trigger>
        <mat-option *ngFor="let subsidiary of allSubsidiaries" [value]="subsidiary.id">
          <span class="tag" [class.selected-tag]="subsidiary.id && subsidiary.id === selectedSubsidiary?.id" [style.margin-right]="subsidiary.is_main ? '10px' : '0'">{{ subsidiary.name }}</span><span class="tag main-subsidiary-tag" *ngIf="subsidiary.is_main">{{ 'Main' | translate }}</span>
        </mat-option>
      </mat-select>
    </div>
    <div class="standard-input">
      <label for="name">{{
        "Catalogs.new_catalog.settings.name" | translate
      }}</label>
      <input
        type="text"
        class="form-control"
        id="name"
        autocomplete="off"
        placeholder='eg. "Brand - Season 2025"'
        name="name"
        formControlName="name"
        data-testid="catalog-name-input"
      />
      <div
        class="error"
        *ngIf="
          basicSettingsForm.get('name')?.invalid &&
          (basicSettingsForm.get('name')?.touched ||
            basicSettingsForm.get('name')?.dirty)
        "
      >
        <small *ngIf="basicSettingsForm.get('name')?.hasError('required')">{{
          "Catalogs.new_catalog.validation.name.required" | translate
        }}</small>
      </div>
    </div>
    <div class="standard-input">
      <label for="description">{{
        "Catalogs.new_catalog.settings.description" | translate
      }}</label>
      <textarea
        class="form-control"
        id="description"
        autocomplete="off"
        placeholder="eg. “Cosmetics products for the summer 2025”"
        name="description"
        formControlName="description"
        rows="4"
        style="resize: vertical"
      ></textarea>
      <div
        class="error"
        *ngIf="
          basicSettingsForm.get('description')?.invalid &&
          (basicSettingsForm.get('description')?.touched ||
            basicSettingsForm.get('description')?.dirty)
        "
      >
        <small
          *ngIf="basicSettingsForm.get('description')?.hasError('required')"
          >{{
            "Catalogs.new_catalog.validation.description.required" | translate
          }}</small
        >
      </div>
    </div>
    <div class="upload-cover-container" *appHasPermission="submitPermission()">
      <input
        #fileInput
        type="file"
        id="cover"
        name="cover"
        class="file-input"
        (change)="onFileSelected($event)"
        accept="image/*"
        hidden
      />
      <span class="upload-icon">
        <app-svg-icon svgIcon="share-cc"></app-svg-icon>
      </span>
      <ng-container *ngIf="!imagePreview; else previewBlock">
        <span class="upload-text">
          <span class="main-label">{{
            "Catalogs.new_catalog.settings.upload_cover" | translate
          }}</span>
          <span class="sub-label"
            >({{ "Catalogs.new_catalog.settings.optional" | translate }})</span
          >
        </span>
      </ng-container>
      <ng-template #previewBlock>
        <span class="cover-preview">
          <img 
            [src]="imagePreview" 
            alt="Cover preview" 
            (error)="onImageError($event)"
            [style.display]="imageLoadError ? 'none' : 'block'"
          />
          <div 
            *ngIf="imageLoadError" 
            class="image-placeholder"
            [style.display]="imageLoadError ? 'flex' : 'none'"
          >
            <mat-icon>image</mat-icon>
            <span>{{ "Catalogs.new_catalog.settings.image_placeholder" | translate }}</span>
          </div>
          <button
            class="action-btn secondary-btn icon-btn remove-btn"
            *appHasPermission="submitPermission()"
            (click)="removeImage()"
          >
            <span class="icon">
              <app-svg-icon svgIcon="trash-cc"></app-svg-icon>
            </span>
          </button>
        </span>
      </ng-template>
      <span class="browse-btn" *appHasPermission="submitPermission()" (click)="fileInput.click()">
        {{ "Catalogs.new_catalog.settings.browse_files" | translate }}
      </span>
    </div>
    <div class="row-checkbox">
      <mat-checkbox
        [checked]="basicSettingsForm.get('hasExpirationDate')?.value"
        [disabled]="!canSubmit"
        (change)="toggleExpirationDate($event)"
      >
      </mat-checkbox>
      <span class="label">
        {{ "Catalogs.new_catalog.settings.has_expiration_date" | translate }}
      </span>
    </div>
    <div class="standard-input has-icon" *ngIf="basicSettingsForm.get('hasExpirationDate')?.value">
      <label for="expiration_date"
        >{{
          "Catalogs.new_catalog.settings.select_expiration_date" | translate
        }}
      </label>
      <div class="input-container">
        <input
          type="text"
          [matDatepicker]="picker"
          formControlName="expiration_date"
          [placeholder]="'Catalogs.new_catalog.settings.select_date' | translate"
          readonly="true"
          (click)="picker.open()"
        />
        <button
          type="button"
          class="btn-icon"
          (click)="picker.open()"
          tabindex="-1"
          aria-label="Open calendar"
        >
          <app-svg-icon svgIcon="calendar-cc"></app-svg-icon>
        </button>
        <mat-datepicker #picker></mat-datepicker>
      </div>

      <div
        class="error"
        *ngIf="
          basicSettingsForm.get('expiration_date')?.invalid &&
          (basicSettingsForm.get('expiration_date')?.touched ||
            basicSettingsForm.get('expiration_date')?.dirty)
        "
      >
        <small
          *ngIf="basicSettingsForm.get('expiration_date')?.hasError('required')"
          >{{
            "Catalogs.new_catalog.validation.expiration_date.required"
              | translate
          }}</small
        >
      </div>
    </div>
    <div class="standard-input" >
      <label for="catalog_type">
        {{
        "Catalogs.new_catalog.settings.catalog_type" | translate
      }}
      </label>
      <select name="catalog_type" disabled>
        <option selected *ngIf="catalogType === 'agents'">{{
          "Catalogs.new_catalog.settings.catalog_types.agent" | translate
        }}</option>
        <option selected *ngIf="catalogType === 'catalogs'">{{
          "Catalogs.new_catalog.settings.catalog_types.customer" | translate
        }}</option>
      </select>
    </div>
  </form>
  <hr />
  <form [formGroup]="pricingRulesForm" class="form pricing-rules">
    <div class="title">
      {{ (catalogType === 'agents' ? "Catalogs.new_catalog.settings.agent_pricing.title" : "Catalogs.new_catalog.settings.customer_pricing.title") | translate }}
      <span class="desc">{{ "Catalogs.new_catalog.settings.agent_pricing.desc" | translate }}</span>
    </div>
    <div class="pricing-rule-row">
      <div class="standard-input">
        <label for="rule">
          {{ "Catalogs.new_catalog.settings.agent_pricing.pricing_rule.title" | translate }}
        </label>
        <mat-select name="rule" formControlName="pricing_rule" [disabled]="isPricingRuleDisabled">
          <mat-select-trigger>
            <span>{{ selectedPricingRuleName }}</span>
          </mat-select-trigger>
          <mat-option *ngFor="let rule of availablePricingRules" [value]="rule.value">
            <span>{{ rule.name | translate }}</span>
          </mat-option>
        </mat-select>
      </div>
      <div class="standard-input has-icon" style="flex: none;">
        <label for="value">
          {{ "Catalogs.new_catalog.settings.agent_pricing.pricing_rule.value" | translate }}
        </label>
        <div class="input-container">
          <input type="number" name="overall_pricing_value" formControlName="overall_pricing_value" min="0" max="100" (input)="onInputRemoveLeadingZero($event, pricingRulesForm, 'overall_pricing_value')" />
          <span class="btn-icon" style="cursor: default;">%</span>
        </div>
        <div class="error" *ngIf="pricingRulesForm.get('overall_pricing_value')?.invalid && (pricingRulesForm.get('overall_pricing_value')?.touched || pricingRulesForm.get('overall_pricing_value')?.dirty)">
          <small *ngIf="pricingRulesForm.get('overall_pricing_value')?.hasError('required')">{{ "Catalogs.new_catalog.validation.value.required" | translate }}</small>
          <small *ngIf="pricingRulesForm.get('overall_pricing_value')?.hasError('min')">{{ "Catalogs.new_catalog.validation.value.min" | translate }}</small>
          <small *ngIf="pricingRulesForm.get('overall_pricing_value')?.hasError('max')">{{ "Catalogs.new_catalog.validation.value.max" | translate }}</small>
        </div>
      </div>
    </div>
    
    <!--  TODO: Apply currencies only for customer catalog -->
    <ng-container *ngIf="catalogType === 'catalogs'">
      <form [formGroup]="currenciesForm" class="form currencies_form">
      <div class="standard-input">
        <label for="default_currency">
          {{ "Catalogs.new_catalog.settings.default_currency" | translate }}
        </label>
        <mat-select name="default_currency" formControlName="default_currency">
          <mat-select-trigger>
            <span class="tag">{{ selectedCurrencyName }}</span>
          </mat-select-trigger>
          <mat-option *ngFor="let currency of allCurrencies" [value]="currency.id">
            <span class="tag">{{ currency.name + ' (' + currency.symbol + ')' }}</span>
          </mat-option>
        </mat-select>
        <div class="error" *ngIf="currenciesForm.get('default_currency')?.invalid && (currenciesForm.get('default_currency')?.touched || currenciesForm.get('default_currency')?.dirty)">
          <small *ngIf="currenciesForm.get('default_currency')?.hasError('required')">{{ "Catalogs.new_catalog.validation.value.required" | translate }}</small>
        </div>
      </div>
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <span class="title" style="font-size: 14px;">{{ "Catalogs.new_catalog.settings.make_this_catalog_multi_currency" | translate }}</span>
        <label class="switch">
          <input type="checkbox" [checked]="currenciesForm.get('is_multi_currency')?.value === true" (change)="toggleMultiCurrency()" [disabled]="!canSubmit || currenciesForm.get('default_currency')?.invalid === true || !currenciesForm.get('default_currency')?.value">
          <span class="slider round"></span>
        </label>
      </div>
      <div class="standard-input" *ngIf="currenciesForm.get('is_multi_currency')?.value === true && !!currenciesForm.get('default_currency')?.value">
        <label for="enabled_currencies">
          {{ "Catalogs.new_catalog.settings.enable_currencies" | translate }}
        </label>
        <mat-select multiple name="enabled_currencies" formControlName="enabled_currencies">
          <mat-select-trigger class="tags-container">
            <ng-container *ngIf="selectedEnabledCurrencies.length > 0">
              <span class="tag" *ngFor="let c of selectedEnabledCurrencies">{{ c.name + ' (' + c.symbol + ')' }}</span>
            </ng-container>
          </mat-select-trigger>
          <mat-option *ngFor="let currency of allCurrencies" [value]="currency.id">
            <span class="tag">{{ currency.name + ' (' + currency.symbol + ')' }}</span>
          </mat-option>
        </mat-select>
      </div>
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <span class="title" style="font-size: 14px;">{{ "Catalogs.new_catalog.settings.show_full_pricing_data" | translate }}</span>
        <label class="switch">
          <input type="checkbox" [checked]="currenciesForm.get('show_full_pricing_data')?.value === true" [disabled]="!canSubmit" (change)="toggleShowFullPricingData()">
          <span class="slider round"></span>
        </label>
      </div>
      </form>
    </ng-container>
    
    <ng-container *ngIf="catalogType === 'agents'">
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <span class="title" style="font-size: 16px;">{{ 'Catalogs.new_catalog.settings.agent_pricing.pricing_rule.apply_extra_discount' | translate }}</span>
        <label class="switch">
          <input type="checkbox" [checked]="hasExtraDiscount" [disabled]="!canSubmit" (change)="toggleExtraDiscount()">
          <span class="slider round"></span>
        </label>
      </div>
      <ng-container *ngIf="hasExtraDiscount">
        <div style="display: flex; justify-content: space-between; align-items: center">
          <span class="desc">{{ 'Catalogs.new_catalog.settings.agent_pricing.pricing_rule.max_extra_discount' | translate }}</span>
          <div class="standard-input has-icon" style="flex: none; width: 200px;">
            <div class="input-container">
              <input type="number" name="extra_discount" formControlName="extra_discount" min="0" max="100" [placeholder]="'Catalogs.new_catalog.settings.optional' | translate" (input)="onInputRemoveLeadingZero($event, pricingRulesForm, 'extra_discount')" />
              <span class="btn-icon" style="cursor: default;">%</span>
            </div>
            <div class="error" *ngIf="pricingRulesForm.get('extra_discount')?.invalid && (pricingRulesForm.get('extra_discount')?.touched || pricingRulesForm.get('extra_discount')?.dirty)">
              <small *ngIf="pricingRulesForm.get('extra_discount')?.hasError('required')">{{ "Catalogs.new_catalog.validation.value.required" | translate }}</small>
              <small *ngIf="pricingRulesForm.get('extra_discount')?.hasError('min')">{{ "Catalogs.new_catalog.validation.value.min" | translate }}</small>
              <small *ngIf="pricingRulesForm.get('extra_discount')?.hasError('max')">{{ "Catalogs.new_catalog.validation.value.max" | translate }}</small>
            </div>
          </div>
        </div>
        <div class="row-checkbox" style="align-items: start;">
          <mat-checkbox
            [checked]="pricingRulesForm.get('extra_discount_blocking')?.value"
            [disabled]="!canSubmit"
            (change)="pricingRulesForm.get('extra_discount_blocking')?.setValue(!pricingRulesForm.get('extra_discount_blocking')?.value)"
          >
          </mat-checkbox>
          <span class="label">
            {{ "Catalogs.new_catalog.settings.agent_pricing.pricing_rule.extra_discount_blocking_order" | translate }}
          </span>
        </div>
      </ng-container>
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <span class="title" style="font-size: 16px;">{{ "Catalogs.new_catalog.settings.show_full_pricing_data" | translate }}</span>
        <label class="switch">
          <input type="checkbox" [checked]="currenciesForm.get('show_full_pricing_data')?.value === true" [disabled]="!canSubmit" (change)="toggleShowFullPricingData()">
          <span class="slider round"></span>
        </label>
      </div>
    </ng-container>
  </form>
  <hr />
  <form [formGroup]="orderAmountForm" class="form order-amount">
    <div class="title">
      {{ "Catalogs.new_catalog.settings.order_amount.title" | translate }}
    </div>
    <div style="display: flex; justify-content: space-between; align-items: center">
      <span class="desc">{{ 'Catalogs.new_catalog.settings.order_amount.min_order_amount' | translate }}</span>
      <div class="standard-input has-icon" style="flex: none; width: 200px;">
        <input type="number" name="min_order_amount" formControlName="min_order_amount" [placeholder]="('Catalogs.new_catalog.settings.optional' | translate) + ' (€)'" (input)="onInputRemoveLeadingZero($event, orderAmountForm, 'min_order_amount')" />
        <div class="error" *ngIf="orderAmountForm.get('min_order_amount')?.invalid && (orderAmountForm.get('min_order_amount')?.touched || orderAmountForm.get('min_order_amount')?.dirty)">
          <small *ngIf="orderAmountForm.get('min_order_amount')?.hasError('required')">{{ "Catalogs.new_catalog.validation.value.required" | translate }}</small>
        </div>
      </div>
    </div>
  </form>
  <hr />
  <form *ngIf="catalogType === 'catalogs' || catalogType === 'agents'" [formGroup]="quantityRulesForm" class="form pricing-rules">
    <div class="title">
      {{ "Catalogs.new_catalog.settings.quantity_rules.stock_preferences" | translate }}
    </div>
    <div style="display: flex; justify-content: space-between; align-items: center;">
      <span class="title" style="font-size: 16px;">{{ 'Catalogs.new_catalog.settings.quantity_rules.display_stock_information' | translate }}</span>
      <label class="switch">
        <mat-slide-toggle
          formControlName="show_stock"
        >
        </mat-slide-toggle>
      </label>
    </div>
    <div style="display: flex; justify-content: space-between; align-items: center;">
      <span class="title" style="font-size: 16px;">{{ 'Catalogs.new_catalog.settings.quantity_rules.allow_product_oversell' | translate }}</span>
      <label class="switch">
        <mat-slide-toggle
          formControlName="can_be_sold_out_of_stock"
        >
        </mat-slide-toggle>
      </label>
    </div>
    <span class="desc">{{ 'Catalogs.new_catalog.settings.quantity_rules.product_with_zero_stock' | translate }}</span>
    <hr />
    <div class="title">
      {{ "Catalogs.new_catalog.settings.quantity_rules.overall_quantity_adjustement" | translate }}
    </div>
    <div style="display: flex; justify-content: space-between; align-items: center">
      <span class="desc">{{ 'Catalogs.new_catalog.settings.quantity_rules.min_product_quantity' | translate }}</span>
      <div class="standard-input has-icon" style="flex: none; width: 200px;">
        <input type="number" name="min_product_quantity" formControlName="min_qte" />
        <div class="error" *ngIf="quantityRulesForm.get('min_qte')?.touched  && quantityRulesForm.get('min_qte')?.hasError('required')">
          <small>{{ "Catalogs.new_catalog.validation.value.required" | translate }}</small>
        </div>
      </div>
    </div>
    <div style="display: flex; justify-content: space-between; align-items: center">
      <span class="desc">{{ 'Catalogs.new_catalog.settings.quantity_rules.increment' | translate }}</span>
      <div class="standard-input has-icon" style="flex: none; width: 200px;">
        <input type="number" name="increment" formControlName="increment" />
        <div class="error">
          <small *ngIf="quantityRulesForm.hasError('increment')">{{ quantityRulesForm.getError('increment') }}</small>
          <small *ngIf="quantityRulesForm.hasError('incrementMin')">{{ quantityRulesForm.getError('incrementMin') }}</small>
        </div>
      </div>
    </div>
    <div style="display: flex; justify-content: space-between; align-items: center">
      <span class="desc">{{ 'Catalogs.new_catalog.settings.quantity_rules.max_product_quantity' | translate }}</span>
      <div class="standard-input has-icon" style="flex: none; width: 200px;">
        <input type="number" name="max_product_quantity" [placeholder]="'Catalogs.new_catalog.settings.optional' | translate" formControlName="max_qte" />
        <div class="error">
          <small *ngIf="quantityRulesForm.get('max_qte')?.touched  && quantityRulesForm.get('max_qte')?.hasError('required')">
            {{"common.required_field" | translate}}
          </small>
          <small *ngIf="quantityRulesForm.hasError('minMax')">{{ quantityRulesForm.getError('minMax') }}</small>
        </div>
      </div>
    </div>

    <div class="handling-units-section">
      <div class="handling-unit-header">
        <div class="header">
          <div class="title-medium">{{ 'Catalogs.product_details.enabled_handling_units' | translate }}</div>
          <img 
            class="image" 
            width="20px" 
            src="assets/icones/info-cc.svg" 
            alt=""
            [matTooltip]="'Catalogs.product_details.enabled_handling_units_info' | translate"
            matTooltipPosition="right"
            style="cursor: pointer;">
        </div>
      </div>
      <div class="standard-input">
        <mat-select 
          name="enabledHandlingUnits"
          [(ngModel)]="enabledHandlingUnits" 
          (ngModelChange)="onEnabledHandlingUnitsChange($event)" 
          multiple
          [disabled]="!canSubmit"
          [ngModelOptions]="{standalone: true}">
          <mat-select-trigger class="tags-container">
            <ng-container *ngIf="getSelectedEnabledHandlingUnits().length > 0">
              <span class="tag" *ngFor="let unit of getSelectedEnabledHandlingUnits()">{{ unit.name }}</span>
            </ng-container>
          </mat-select-trigger>
          <mat-option *ngFor="let unit of availableHandlingUnits" [value]="unit.id">
            <span class="tag">{{ unit.name }}</span>
          </mat-option>
        </mat-select>
      </div>

      <div class="handling-unit-header">
        <div class="header">
          <div class="title-medium">{{ 'Catalogs.product_details.default_handling_unit' | translate }}</div>
          <img 
            class="image" 
            width="20px" 
            src="assets/icones/info-cc.svg" 
            alt=""
            [matTooltip]="'Catalogs.product_details.default_handling_unit_info' | translate"
            matTooltipPosition="right"
            style="cursor: pointer;">
        </div>
      </div>
      <div class="standard-input">
        <mat-select 
          name="defaultHandlingUnit"
          [(ngModel)]="defaultHandlingUnit" 
          (ngModelChange)="onDefaultHandlingUnitChange($event)" 
          [disabled]="!canSubmit || !enabledHandlingUnits || enabledHandlingUnits.length === 0"
          [ngModelOptions]="{standalone: true}">
          <mat-select-trigger class="tags-container">
            <ng-container *ngIf="defaultHandlingUnit">
              <span class="tag">{{ getDefaultHandlingUnitLabel() }}</span>
            </ng-container>
          </mat-select-trigger>
          <mat-option *ngFor="let unit of getFilteredHandlingUnitsForDefault()" [value]="unit.id">
            <span class="tag">{{ unit.name }}</span>
          </mat-option>
        </mat-select>
      </div>
    </div>

    <div class="section">
      <ng-container *ngIf="objectCustomFields && objectCustomFields.definitions.length > 0">
        <hr />
        <div class="section-title">
          {{ "custom_fields.custom_fields" | translate }}
          <ui-button
            *appHasPermission="submitPermission()"
            type="secondary"
            icon="pen-cc"
            iconSize="large"
            iconPosition="start"
            (click)="editObjectCustomFields()">
          </ui-button>
        </div>
        <app-object-custom-fields-view
            [objectCustomFields]="objectCustomFields"
            [currentLanguage]="currentLanguage"
        ></app-object-custom-fields-view>
      </ng-container>
    </div>
  </form>
</div>
